'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'location',
  aliases: [],
  colors: [],
  path: _react2.default.createElement('path', {
    unicode: '\uF041',
    glyphName: 'map_marker',
    transform: 'scale(1,-1) translate(0, -1150)',
    horizAdvX: '1024',
    d: 'M768 896q0 106 -75 181t-181 75t-181 -75t-75 -181t75 -181t181 -75t181 75t75 181zM1024 896q0 -109 -33 -179l-364 -774q-16 -33 -47.5 -52t-67.5 -19t-67.5 19t-46.5 52l-365 774q-33 70 -33 179q0 212 150 362t362 150t362 -150t150 -362z'
  }),
  viewBox: '0 0 1536 1000'
};


//////////////////
// WEBPACK FOOTER
// ./~/tanda-components/Icon/svgs/location.js
// module id = 1593
// module chunks = 0